<div class="online-status-group">
  <div *ngIf="onlineStatus === 'online'" class="online">
    <span>{{onlineStatusMessage}}</span>
  </div>

  <div *ngIf="onlineStatus === 'offline'" class="offline">
    <span>{{onlineStatusMessage}}</span>
  </div>
</div>